import React, { useEffect } from 'react';
import '../ServicesStyles/ServiceAbout.css';

const techStack = [
  { icon: 'bi-display', label: 'React.js' },
  { icon: 'bi-server', label: 'Node.js' },
  { icon: 'bi-phone', label: 'Flutter' },
  { icon: 'bi-database', label: 'MySQL' },
  { icon: 'bi-cloud', label: 'AWS' },
  { icon: 'bi-shield-check', label: 'Security' },
];

const features = [
  {
    icon: 'bi bi-hand-index-thumb',
    title: 'Maintenance and Support',
    text: 'Regular IT support and maintenance is crucial for a business as it helps in increasing productivity, improving security, reducing costs.',
  },
  {
    icon: 'bi bi-gear',
    title: 'Secure Applications',
    text: 'Implement security and strong authentication for applications procedures and systems to protect your applications and their data privacy.',
  },
  {
    icon: 'bi bi-box-seam',
    title: 'Custom Software Development',
    text: 'We understand the value of your data. Our custom software solutions are designed with the highest standards of security and confidentiality.',
  },
  {
    icon: 'bi bi-cloud',
    title: '24 × 7 Support',
    text: 'At Bellary Info Tech Solutions, we\'re here for you 24/7. Our expert team is always ready to assist you, ensuring your business runs smoothly.',
  },
];

const ServiceAbout = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="bodyofservice">
      <div className="container">
        <div className="content" data-animate="slideInLeft">
          <p className="description">
            Experience Bellary Info Tech Solutions transformation strategy, supercharge your competitive
            edge and achieve exponential business outcomes. BITS powers end-to-end software and billing
            transformation solutions and services that help organizations implement complex global-scale
            transformation programs.
          </p>

          <div className="features">
            {features.map((f, i) => (
              <div className="feature" key={i}>
                <i className={`${f.icon} feature-icon`}></i>
                <div>
                  <h3 className="feature-title">{f.title}</h3>
                  <p className="feature-text">{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="form-container" data-animate="slideInRight">
          <h3 className="form-title">Our Technology Stack</h3>
          <div className="tech-stack-grid">
            {techStack.map((tech, i) => (
              <div className="tech-item" key={i}>
                <i className={`bi ${tech.icon}`}></i>
                <span>{tech.label}</span>
              </div>
            ))}
          </div>
          <div className="service-cta-block">
            <div className="service-cta-stat">
              <span className="service-cta-num">10+</span>
              <span className="service-cta-label">Projects Delivered</span>
            </div>
            <div className="service-cta-stat">
              <span className="service-cta-num">5+</span>
              <span className="service-cta-label">Years Experience</span>
            </div>
            <div className="service-cta-stat">
              <span className="service-cta-num">10+</span>
              <span className="service-cta-label">Happy Clients</span>
            </div>
          </div>
          <p className="service-cta-tagline">
            Delivering excellence with every line of code.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceAbout;
